module.exports = __webpack_public_path__ + "static/media/Img_Fondo_Usuario.009c25f7.jpg";